import { Input } from "@babackapp/ui/components/input";
import { DEFAULT_FONT } from "../../utils/constants";
import { useBlockPanelPropsContext } from "./panel-container";
import PanelContent from "./panel-content";

export default function PanelBlockFont() {
  const blockProps = useBlockPanelPropsContext();
  const value = blockProps.block.font || DEFAULT_FONT;

  const handleUpdate = (font: string) => {
    blockProps.formAPI.updateField(blockProps.formAPI.blockPath, {
      ...blockProps.block,
      font,
    });
  };

  return (
    <PanelContent title="Font">
      <Input
        value={value}
        className="w-full text-sm h-8"
        onChange={(e) => handleUpdate(e.target.value)}
      />
    </PanelContent>
  );
}
